
import styles from "./Daetong.module.css";
import React, { useState, useRef, useMemo, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import HeaderMain from './component/HeaderMain';
import { Link, Navigate, Outlet, Route, Routes, useNavigate } from 'react-router-dom';
import $ from "jquery";
import FortuneList from './routes/FortuneList';
import FortuneInfo from './routes/FortuneInfo';
import FortuneSelect from './routes/FortuneSelect';
import PersonaCard from './component/PersonaCard';
import Constellation from './component/Constellation';
import Loading from './component/Loading';
import NotFound from './routes/NotFound';
import UnseResult from './routes/UnseResult';
import { UnseProvider } from './context/UnseContext';
import AgreePrivacy from './routes/AgreePrivacy';
import { Pagination } from 'swiper/modules';
import { setHead } from "../utils/head";
import styled, { keyframes } from 'styled-components';
import { Helmet } from "react-helmet-async";
import AgreePrivacyPopUp from "./component/AgreePrivacyPopUp";

const cloudFloat = keyframes`
    0% {
        transform: translateX(540px);
        opacity: 0;
    }
    10% {
        opacity: 0.9;
    }
    90% {
        opacity: 0.9;
    }
    100% {
        transform: translateX(-200px);
        opacity: 0;
    }
`;

const cloudFloat2 = keyframes`
    0% {
        transform: translateX(-540px); 
        opacity: 0;
    }
    10% {
        opacity: 0.9;
    }
    90% {
        opacity: 0.9;
    }
    100% {
        transform: translateX(540px);
        opacity: 0;
    }
`;

const Cloud = styled.img`
    position: absolute;
    top: 40%;
    width: 100%;
    max-width:60px;
    animation: ${cloudFloat} 30s linear infinite;

    @media (max-width: 520px) {
        max-width:11.5385vw;
    }
`;

const Cloud2 = styled.img`
    position: absolute;
    top: 57%;
    width: 100%;
    max-width:215px;
    animation: ${cloudFloat2} 20s linear infinite;

    @media (max-width: 520px) {
        max-width:41.3462vw;
    }
`;

const Cloud3 = styled.img`
    position: absolute;
    top: 40%;
    width: 100%;
    max-width:115px;
    animation: ${cloudFloat} 30s linear infinite;

    @media (max-width: 520px) {
        max-width:22.1154vw;
    }
`;

const Cloud4 = styled.img`
    position: absolute;
    top: 70%;
    width: 100%;
    max-width:215px;
    animation: ${cloudFloat2} 20s linear infinite;

    @media (max-width: 520px) {
        max-width:41.3462vw;
    }
`;

const Cloud5 = styled.img`
    position: absolute;
    top: 50%;
    width: 100%;
    max-width:60px;
    animation: ${cloudFloat2} 25s linear infinite;

    @media (max-width: 520px) {
        max-width:11.5385vw;
    }
`;



function DaetongApp() {
    const [fortuneList, setFortuneList] = useState(false);
    const [agreePrivacyTab, setAgreePrivacyTab] = useState(false);
    const [data, setData] = useState(null);
    const [unseResult, setUnseResult] = useState(null);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const APIKEY = process.env.REACT_APP_UNSE_API_KEY;
    const memberId = localStorage.getItem("daetong_memberId");
    const siteCode = process.env.REACT_APP_SITE_CODE_DAETONG;
    // const isLogin = (memberId != 'null') || !memberId;


    const navigate = useNavigate();

    useEffect(() => {
        // 메인 데이터 가져오기
        $.ajax({
            url: `${API_BASE_URL}/getMain`,
            type: "POST",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({ "member_id": memberId, "site_code": siteCode }),
            cache: false,
            headers: {
                APIKEY: APIKEY,
            },
            success: function (res) {
                if (res.code != "0") {
                    alert(res.msg); return false;
                }
                // console.log("응답:", res);
                setData(res);
            },
            error: function (xhr, status, err) {
                console.error("에러:", err);
                // console.log("상태:", xhr.status, "응답:", xhr.responseText);
            },
        });

        localStorage.setItem("daetong_memberId", memberId);

        setHead("운수대통방", "/image/favicon2.png");

    }, []);



    // function getUnseResult(unseId, memberId) {
    //   $.ajax({
    //     url: `${API_BASE_URL}/getUnse`, 
    //     type: "POST",
    //     contentType: "application/json",
    //     dataType: "json",
    //     data: JSON.stringify({"member_id":memberId, "unse_id":unseId}),
    //     cache: false,
    //     headers: {
    //       APIKEY: APIKEY,
    //     },
    //     success: function (res) {
    //       if(res.code != "0") {
    //         alert(res.msg); return false;
    //       }
    //       console.log("응답:", res);
    //       setUnseResult(res);
    //       // console.log(unseResult.unseResult);
    //     },
    //     error: function (xhr, status, err) {
    //       console.error("에러:", err);
    //       console.log("상태:", xhr.status, "응답:", xhr.responseText);
    //     },
    //   }); return;
    // }



    if (!data) {
        return;
    }

    const cards = data.unseList;
    const memberInfo = data.memberInfo;
    const menuList = data.menuList;
    const personaList = data.personaList || [];

    

    if (agreePrivacyTab) {
        document.body.style.overflow = "hidden"; // 팝업 열림: 스크롤 막기
    } else {
        document.body.style.overflow = "";       // 팝업 닫힘: 원복
    }


    return (
        <UnseProvider>
            <div className={`App ${styles.AppDaetong}`}>
                {/* <>
                    <Helmet>
                        <meta name="description" content="대통운수방에서는 무료로 오늘의 운세와 궁합 정보를 제공합니다. 쉽고 빠르게 운세를 확인하세요." />
                        <meta name="keywords" content="운세, 오늘의 운세, 궁합, 무료 운세, 별자리 운세" />

                        <meta property="og:type" content="website" />
                        <meta property="og:title" content="대통운수방 - 무료 오늘의 운세와 궁합 서비스" />
                        <meta property="og:description" content="대통운수방에서 무료로 오늘의 운세와 궁합 정보를 확인하세요. 쉽고 빠른 운세 서비스로 운빨을 체크하세요." />

                        <meta name="twitter:card" content="summary_large_image" />
                        <meta name="twitter:title" content="대통운수방 - 무료 오늘의 운세와 궁합 정보" />
                        <meta name="twitter:description" content="대통운수방에서 무료로 오늘의 운세와 궁합을 확인하세요. 빠르고 간편한 운세 서비스로 운을 점쳐보세요." />
                    </Helmet>
                </> */}
                <div className='inner'>
                    <Cloud src={process.env.PUBLIC_URL + '/daetongImg/cloud.png'} alt="cloud" />
                    <Cloud2 src={process.env.PUBLIC_URL + '/daetongImg/cloud2.png'} alt="cloud" />
                    <Cloud5 src={process.env.PUBLIC_URL + '/daetongImg/cloud.png'} alt="cloud" />
                    <Routes>
                        <Route index element={
                            <>
                                <div className={`mainContent ${styles.mainContent}`}>
                                    <div className={`mainInner ${styles.mainInner_daetong}`}>
                                        <HeaderMain variant="mainHeader" menuList={menuList} />
                                        {/* <Constellation></Constellation> */}
                                        <div className='meadBox meadBox_daetong'>
                                            <div className='main_top_banner'>
                                                <h4 className={`bannerTitle ${styles.bannerTitle_daetong}`}>
                                                    <img src={process.env.PUBLIC_URL + '/image/daetong_logo.png'} alt='운수대통방' />
                                                </h4>

                                                <div className='daetongUserInfo'>
                                                    <p className="content_scroll top">
                                                        <img src={process.env.PUBLIC_URL + '/daetongImg/content_scroll.png'} alt='' />
                                                    </p>
                                                    <div className='userInfo_text'>
                                                        <div className="userInfo_text_inner">
                                                            <h5 className='userInfo_title'>{memberInfo.TITLE}</h5>
                                                            <span className="line"></span>
                                                            <Link to="FortuneInfo" className='userScore'>
                                                                <img src={process.env.PUBLIC_URL + `/daetongImg/today_score${memberInfo.TODAY_SCORE}.png`} />
                                                            </Link>
                                                            <div className='userInfo_sub'>
                                                                <FortuneResult memberInfo={memberInfo}></FortuneResult>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p className="content_scroll bottom">
                                                        <img src={process.env.PUBLIC_URL + '/daetongImg/content_scroll.png'} alt='' />
                                                    </p>
                                                </div>

                                                <div className="daetongCollect">
                                                    <h4 className="collectTitle">
                                                        <img src={process.env.PUBLIC_URL + `/daetongImg/collect_icon.png`} />
                                                        점술인 선택
                                                    </h4>
                                                    <ul className={`personaList ${styles.personaList}`}>
                                                        {
                                                            personaList.map((persona, i) => (
                                                                <PersonaCard
                                                                    key={persona.ID || i}
                                                                    persona={persona}
                                                                    onClick={() => navigate(`/daetong/FortuneSelect/${persona.ID}`)}
                                                                />
                                                            ))
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                            {/* <div className='main_card_list'>
                                                <div className='main_card_inner'>
                                                    <FortuneCards cards={cards} memberId={memberId} />
                                                </div>
                                            </div> */}
                                            {/* <Link to="FortuneList" className='listBtn'>
                                                <img src={process.env.PUBLIC_URL + '/image/daetong_mainList_menu.png'} />
                                            </Link> */}
                                        </div>

                                    </div>
                                </div>
                            </>
                        } />
                        <Route path="FortuneInfo/:orderId" element={
                            <div className={`FortuneInfoPage ${styles.FortuneInfoPage_daetong}`}>
                                <HeaderMain variant="backHeader" menuList={menuList} />
                                {/* <Constellation></Constellation> */}
                                <FortuneInfo cards={cards} menuList={menuList} setAgreePrivacyTab={setAgreePrivacyTab} Loading={Loading} Constellation={Constellation} personaList={personaList} />
                                <div className={`agreePrivacyPage agreePopUp ${agreePrivacyTab ? 'active' : ''} ${styles.agreePrivacyPage_daetong}`}>
                                    <AgreePrivacyPopUp setAgreePrivacyTab={setAgreePrivacyTab}/>
                                </div>
                            </div>
                        } />
                        <Route path="FortuneInfo" element={
                            <div className={`FortuneInfoPage ${styles.FortuneInfoPage_daetong}`}>
                                <HeaderMain variant="backHeader" menuList={menuList} />
                                {/* <Constellation></Constellation> */}
                                <FortuneInfo cards={cards} menuList={menuList} setAgreePrivacyTab={setAgreePrivacyTab} Loading={Loading} Constellation={Constellation} personaList={personaList} />
                                <div className={`agreePrivacyPage agreePopUp ${agreePrivacyTab ? 'active' : ''} ${styles.agreePrivacyPage_daetong}`}>
                                    <AgreePrivacyPopUp setAgreePrivacyTab={setAgreePrivacyTab}/>
                                </div>
                            </div>
                        } />
                        <Route path='UnseResult' element={
                            <div className={`UnseResultPage ${styles.UnseResultPage_daetong}`}>
                                <HeaderMain variant="backHeaderOnly" menuList={menuList} />
                                {/* <Constellation></Constellation> */}
                                <UnseResult unseResult={unseResult} personaList={personaList} />
                            </div>
                        } />
                        <Route path='FortuneList' element={
                            <div className={`fortuneListPage ${styles.fortuneListPage_daetong}`}>
                                <HeaderMain variant="backHeader" menuList={menuList} />
                                <FortuneList cards={cards} fortuneList={fortuneList} />
                                {/* <Constellation></Constellation> */}
                            </div>
                        } />
                        <Route path='AgreePrivacy' element={
                            <div className={`agreePrivacyPage ${styles.agreePrivacyPage_daetong}`}>
                                <HeaderMain variant="subHeader" setFortuneList={setFortuneList} menuList={menuList} />
                                <AgreePrivacy></AgreePrivacy>
                            </div>
                        } />

                        {/* 페르소나 선택 후 운세 선택 */}
                        <Route path='FortuneSelect/:personaId' element={
                            <div className={`fortuneSelectPage ${styles.fortuneSelectPage}`}>
                                <HeaderMain variant="backHeader" menuList={menuList} />
                                <FortuneSelect cards={cards} personaList={personaList} />
                            </div>
                        } />

                        {/* 페르소나 + 운세 조합 */}
                        <Route path="FortuneInfo/:personaId/:orderId" element={
                            <div className={`FortuneInfoPage ${styles.FortuneInfoPage_daetong}`}>
                                <HeaderMain variant="backHeader" menuList={menuList} />
                                <FortuneInfo cards={cards} menuList={menuList} setAgreePrivacyTab={setAgreePrivacyTab} Loading={Loading} Constellation={Constellation} personaList={personaList} />
                                <div className={`agreePrivacyPage agreePopUp ${agreePrivacyTab ? 'active' : ''} ${styles.agreePrivacyPage_daetong}`}>
                                    <AgreePrivacyPopUp setAgreePrivacyTab={setAgreePrivacyTab}/>
                                </div>
                            </div>
                        } />

                        <Route path='*' element={<NotFound />} />
                    </Routes>

                    <div className="mountainPeak_box">
                        <div className="mountainPeak_inner">
                            <Cloud3 src={process.env.PUBLIC_URL + '/daetongImg/cloud.png'} alt="cloud" />
                            <Cloud4 src={process.env.PUBLIC_URL + '/daetongImg/cloud2.png'} alt="cloud" />
                            <img src={process.env.PUBLIC_URL + '/daetongImg/mountain_peak.png'} />
                        </div>
                    </div>
                </div>
            </div>
        </UnseProvider>
    );
}



function FortuneResult({ memberInfo }) {
    return (
        <div dangerouslySetInnerHTML={{ __html: memberInfo.CONTENT }} />
    );
}


export default DaetongApp;
